if (navigator.userAgent.indexOf('Safari') != -1 &&
  navigator.userAgent.indexOf('Chrome') == -1) {
  document.body.className += " safari";
}


(function ($) {
  
  if( $(window).width() > 767 ){
    setTimeout(() => {   
      $(".geolizr-currency-switch-wrapper").appendTo( $(".header--currency") );
    }, 2000);
  }
  
  var myProductText = "test";
  var myVariantText = "";
  var myTitle = "";
  
  function updateImages(){
    myProductText = $(".product-page--title").text().trim().replace(/\s/g, "").toUpperCase();
    myVariantText = $("#product-page--select-option-0 option:selected").val().replace(/\s/g, "").toUpperCase();
    myTitle = myVariantText ? myVariantText !== "SAMPLE" ? myVariantText : myProductText : myProductText;
    
    // console.log(myTitle);

    // $(".product-page--thumb").removeClass("active");

    // $(".image--container img[data-srcset*='" + myTitle + "']").parents(".product-page--thumb").addClass("active");
    // $(".image--container img[data-src*='" + myTitle + "']").parents(".product-page--thumb").addClass("active");
  }

  if ($(".template--product").length) { 
    // updateImages();
    
    // $("body").on("change", "#product-page--select-option-0", function(){
    //   console.log(myProductText);
    //   updateImages();
    // });   
  }
        
})(jQuery)

/* Most of the designs which have a Peel & Stick version have equivalents for every colorway, but a few do not.
  For these, we only want to show the link to the Peel & Stick page if the correct colorway is selected */
const variantsWithPeelAndStickVersion = [
  {"product_sku":"ad083","variant_skus":["AD083-2","AD083-3","AD083-4"]},
  {"product_sku":"ad357","variant_skus":["AD357-3"]},
  {"product_sku":"av073","variant_skus":["AV073-1"]},
  {"product_sku":"av092","variant_skus":["AV092-2"]},
  {"product_sku":"ja100","variant_skus":["JA100-4","JA100-5"]},
  {"product_sku":"ja107","variant_skus":["JA107-1","JA107-2","JA107-3","JA107-4"]},
  {"product_sku":"ja108","variant_skus":["JA108-1","JA108-2","JA108-4","JA108-5","JA108-6"]},
  {"product_sku":"ja109","variant_skus":["JA109-2","JA109-3","JA109-4","JA109-6"]},
  {"product_sku":"ja111","variant_skus":["JA111-4","JA111-5","JA111-6"]},
  {"product_sku":"ja113","variant_skus":["JA113-2","JA113-3","JA113-4","JA113-6"]},
  {"product_sku":"sow100","variant_skus":["SOW100-1"]},
  {"product_sku":"sow110","variant_skus":["SOW110-1"]},
  {"product_sku":"sow112","variant_skus":["SOW112-1"]},
  {"product_sku":"sow114","variant_skus":["SOW114-1"]}
];

const filterPeelAndStickLink = function() {
  let product_sku = theme.product_json.handle.split('-').slice(-1)[0];
  let variant = Astek.getSelectedVariant();
  let variant_sku = Astek.cleanSkuForDisplay(variant.sku);

  let found = variantsWithPeelAndStickVersion.find(i => i.product_sku === product_sku);
  if (!found) {
    return true;
  }
  // console.log(found.variant_skus.indexOf(variant_sku) > -1);
  if (found.variant_skus.indexOf(variant_sku) > -1) {
    return true;
  }
  return false;
};
const displayPeelAndStickLink = function() {
  if (filterPeelAndStickLink()) {
    $('#peel-and-stick-link-container').show().html('<a class="button" href="/products/'+Astek.peel_and_stick_version_handle+'">Available on Peel &amp; Stick Wallpaper</a>');
  } else {
    $('#peel-and-stick-link-container').hide();
  }
};

const displayTraditionalLink = function() {
  $('#peel-and-stick-link-container').show().html('<a class="button" href="/products/'+Astek.traditional_version_handle+'">Available on Traditional Wallpaper</a>');
}

$(function(){
  if (typeof Astek.peel_and_stick_version_handle !== 'undefined') {
    displayPeelAndStickLink();
    $('#product-page--select-option-0').change(function(){
      displayPeelAndStickLink();
    });
  }

  if (typeof Astek.traditional_version_handle !== 'undefined') {
    displayTraditionalLink();
  }
});


/*
Owl slider. When mobile users scroll through the slideshow of images, the
corresponding selected colorway should change, and the displayed SKU should update.
2023-02-08 EH
*/
const getSkuFromImageUrl = function (url) {
  let filename = url.split("/").pop();
  let sku = filename.split('_')[0];
  return sku;
};

const getImageUrlFromCurrentImage = function(current_image) {
  if (typeof(current_image.dataset) !== 'undefined') {
    if (typeof(current_image.dataset.src) !== 'undefined') {
      image_url = current_image.dataset.src;
    } else if (typeof(current_image.dataset.srcset) !== 'undefined') {
      image_url = current_image.dataset.srcset.split(' ')[0];
    }
  }
  return image_url;
};

const updateSelectors = function(current_index) {
  // Colorway selector
  let $select = $("#product-page--select-option-0");
  let $options = $("#product-page--select-option-0 option");
  let $option = $("#product-page--select-option-0 option")[current_index];

  if (typeof($option) != 'undefined') {
    $select.val($option.value);
  }

  // "Full" or "Sample" selector
  if (typeof(productOptions) != 'undefined' && productOptions[1] == "Full Order or Sample") {
    $select = $("#product-page--select-option-1")[0];
    if (typeof($select) != 'undefined') {
      $select.selectedIndex = 0;
    }
  }

  // Material selector
  if (typeof(productOptions) != 'undefined' && productOptions[2] == "Material") {
    $select = $("#product-page--select-option-2")[0];
    if (typeof($select) != 'undefined') {
      $select.selectedIndex = 0;
    }
  }

  // Quantity field
  if (typeof(Astek.calculator_settings.minimum != 'undefined')) {
    $('#quantity').val(Astek.calculator_settings.minimum);
  }
};

// const updateSku = function(current_image) {
//   let image_url = getImageUrlFromCurrentImage(current_image);
//   let sku = getSkuFromImageUrl(image_url);
//   // console.log("updateSku sku: " + sku);

//   if ($('#product-sku').html() != sku) {
//     $('#product-sku').html(sku);
//     let firstDiv = $('.dropdown-body').last().find('dl').first().find('div').first();
//     if (firstDiv.find('dt').html() == 'SKU') {
//         firstDiv.find('dd').html(sku);
//     }
//     return sku;
//   }

//   return false;
// };

const updateSku = function(current_index) {
  let sku = variant_skus[current_index];
    
  if ($('#product-sku').html() != sku) {
    $('#product-sku').html(sku);
    let firstDiv = $('.dropdown-body').last().find('dl').first().find('div').first();
    if (firstDiv.find('dt').html() == 'SKU') {
        firstDiv.find('dd').html(sku);
    }
    return sku;
  }

  return false;
};

const updateMobileSkuAndSelectors = function(current, count) {
  if (typeof(productOptions) != 'undefined' && productOptions[0] == "Colorway") {
    
    // const current_image = $('.owl-item img')[current];
    // If colorway was changed, update selectors
    // if (current_sku = updateSku(current_image)) {
    //   updateSelectors(current);
    // }

    // If colorway was changed, update selectors
    if (current_sku = updateSku(current)) {
      updateSelectors(current);
    }
    
  }
};

/*
End Owl slider handling
2023-02-08 EH
*/

